import { BenefitProgram } from '../enums/benefit-program-type.enum';
import { OfferingVariants } from '../enums/offering-variants.enum';
import { Price } from './price.model';

export enum NumberCategory {
  All = 'All',
  Voice = 'Voice',
  MBB8 = 'MBB8',
  MBB12 = 'MBB12',
  AccessNumber = 'AccessNumber',
  AccessNumberMobile = 'AccessNumberMobile',
  Invalid = 'Invalid',
  Trilling = 'Trilling',
}

export enum CustomerClassification {
  B2C = 'B2C',
  B2B = 'B2B',
}

export enum ProductClassification {
  Voice = 'Voice',
  MBB = 'MBB',
  M2M = 'M2M',
}

export class SubscriptionOfferingPrice {
  price: Price;
  isCampaign: boolean;
  campaignPeriod: number;
  isCustomerDiscount: boolean;
  originalPrice: Price;
}

export enum BindingType {
  Sim = 'Sim',
  Handset = 'Handset',
}

export class Binding {
  bindingType: BindingType;
  period: number;
  expirationDate: Date;
  terminationFee: Price;
  terminationAdminFee: Price;
  terminationDiscountFee: Price;
}

export class SubscriptionOffering {
  id: string;
  name: string;
  shortName: string;
  isActive: boolean;
  numberCategory?: NumberCategory;
  customerClassification: CustomerClassification;
  productClassification: ProductClassification;
  monthlyPrice: SubscriptionOfferingPrice;
  dataVolume: number;
  dataVolumeText: string;
  benefitProgram?: BenefitProgram;
  commitmentPeriod: number;
  bindings: Binding[];
  variant?: OfferingVariants;
  isEquipmentUpgradeCompatible: boolean;
  upperAgeLimit?: number;
  lowerAgeLimit?: number;
}
